export default "__VITE_ASSET__CzXyWDVs__"